/**
 * Interface for StillImageBackground background images config
 */
import {IGameModeChangedData, GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { Sprite, Point, Graphics, Container, BLEND_MODES  } from "pixi.js";
import { TimelineMax, Power2, TweenLite } from "gsap";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { IDimConfig, LayoutDimData, ResizeHelper } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";

import { IStillImageBackgroundImagesConfig, IStillImageBackgroundConfig } from "@nolimitcity/slot-game/bin/game/background/StillImageBackground"
import { Background } from "@nolimitcity/slot-game/bin/core/background/Background";
import { SanSymbolData } from "../../../engine/Symbol/SanSymbolData";
import { SanEngineManager } from "./../../../engine/SanEngineManager";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { Sequence } from "@nolimitcity/slot-game/bin/core/displayobject/Sequence";
import { ImgLoader } from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import { SanGameAssets } from "../../../SanGameAssets";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { SanGameConfig } from "../../../SanGameConfig";
import { JumpingWildController } from "../../independent/jumpingWild/JumpingWildController";
import { SpinePlayer } from "../../../proto/SpinePlayer";
import { GameSetting } from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { BalanceEvent } from "@nolimitcity/slot-game/bin/core/balance/event/BalanceEvent";
import { StageEvent } from "@nolimitcity/slot-game/bin/core/stage/event/StageEvent";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { SoundConfig } from "../../../SoundConfig";
import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import { JurisdictionNames } from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/GameClientConfiguration";


export class IntroAnimation extends BaseView {
    protected readonly posterDim:IDimConfig = {
        dimOrientation : {
            landscape :{
                scale:      new Point( 1, 1),
                position:   new Point( 360, 360),
                layout :{
                    left:   new Point( 360, 360),
                    right:   new Point( 360, 360)
                }
            },
            portrait :{
                scale:      new Point( 1, 1),
                position:   new Point( 360, 300)
            }
        },
        WIDTH: 900,
        HEIGHT: 540,
    };

    protected tl_end:TimelineMax;
    private intro_Spine:SpinePlayer;

    private clicked:boolean = false;
    private static _instance:IntroAnimation;

    public get dim():LayoutDimData{ return ResizeHelper.calcDim(this.posterDim); };

    public static get JuriGFXUSSettings():boolean {
        return !!SlotGame.api.gameClientConfiguration.useCensoredGfxUS;
    }

    public static get instance():IntroAnimation{
        return this._instance
    }

    constructor() {
        super();
        if(IntroAnimation.JuriGFXUSSettings) return;

        IntroAnimation._instance = this;
        this.buttonMode = false;
        this.interactive = true;
        this.on('pointertap', () => this.clean());
        EventHandler.addEventListener(this, BalanceEvent.BET, () => this.clean());
    }

    protected initAnimations():void {
        StageManager.getLayer(SanGameConfig.instance.LAYERS.INTRO.name).addChild(this);
        this.intro_Spine = this.addChild(new SpinePlayer("intro"));
    }


    public play():void{
        const animationNameValue:number = MathHelper.randomIntInRange(1, 5);
        if(SlotGame.api.gameClientConfiguration.jurisdictionName === JurisdictionNames.ITALY){
            const juriName:string = animationNameValue  < 3 ? "_ITALY" : "";
            this.intro_Spine.play({name: "Intro_Sym_" + animationNameValue + juriName, loop:false}).eventCallback("onComplete",() => this.clean());
        }else{
            this.intro_Spine.play({name: "Intro_Sym_" + animationNameValue, loop:false}).eventCallback("onComplete",() => this.clean());
        }
        TweenLite.to(this,0.2,{}).eventCallback("onComplete",() => {if(!this.clicked) SoundManager.playSoundEffect(SoundConfig.instance.INTRO_FOLDER)}) 
    }

    public clean():void{
        if(this.tl_end || this.children.length == 0) return;

        this.tl_end = new TimelineMax({onComplete:() => this.remove()});
        SoundManager.stopSoundEffect(SoundConfig.instance.INTRO_FOLDER,250);
        
        this.tl_end.fromTo(this,0.25,{alpha:1},{alpha:0});
        this.tl_end.play();
    }

    private remove():void{
        EventHandler.removeEventListener(this, BalanceEvent.BET);
        EventHandler.removeEventListener(this, StageEvent.STAGE_RESIZED);
        this.parent.parent.removeChild(this.parent);
        this.parent.removeChild(this);
        this.destroy({children:true});
    }

    protected onResize():void{
        this.scale = this.dim.scale;
        this.position = this.dim.position;
    }
}